module.exports = __webpack_public_path__ + "static/media/visit.ad2d8008.svg";